export const delay = async (time: number) => new Promise((resolve) => setTimeout(resolve, time))

export const generateTempId = (): string => {
  return `temp_${crypto.randomUUID()}`
}

export const safeJsonParse = <T>(value: string | null): T | null => {
  if (!value) {
    return null
  }

  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}
